
import { useEffect } from 'react'
import Select from 'react-select'
import { WTPPumpCategoryDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'

export const WTPPumpCategoryNoDDL = (props) => {
    const { Category, setCategory, rowData, Flag, IsPost } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user

    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            M_UserID: UserID,
            token: token,
            Flag: Flag,
        }
        dispatch(WTPPumpCategoryDDLAPI({ data }))
    }, [IsPost])

    const { WTPPumpCategoryData } = useSelector(state => state.WTPPumpCategoryDDL)

    useEffect(() => {
        handleWTPPumpCategoryDDL()
    }, [WTPPumpCategoryData])

    const handleWTPPumpCategoryDDL = () => {
        // console.log(DeptDDLDataa)
        if (WTPPumpCategoryData && WTPPumpCategoryData.table && WTPPumpCategoryData.table.length > 0) {
            let list = WTPPumpCategoryData.table.map((item, index) => ({
                value: item.m_wtP_PumpCategoryID,
                label: item.pumpCategory,
            }))
            setCategory({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_wtP_PumpCategoryID : Ward?.ID,
                Label: Flag === 'Update' ? rowData.pumpCategory : Ward?.Label,
            })
        }
        else {
            setCategory({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofEmployee"><b>Pump Category</b></label>
            <Select
                // isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: Category.ID, label: Category.Label }}
                onChange={(e) => {
                    e ?
                        setCategory({ ...Category, ID: e.value, Label: e.label })
                        :
                        setCategory({ ...Category, ID: 0, Label: "Select..." })

                }}
                options={Category.DDL}
            />
        </div>
    )
}